module.exports = __webpack_public_path__ + "img/progress_header.1b2ba8f2.png";